// Dedupes concurrent calls that share the same `key`: if a call for that key is already in
// flight, subsequent callers get the same promise instead of triggering another request. Once
// the call settles (resolve or reject), the key is freed so the next call starts a fresh
// request/attempt.
//
// Ported from `InFlightRequests` in universal-ovm-fe's src/api/in-flight-requests.ts, trimmed to
// plain JS (this app doesn't use TypeScript).
//
// Use this to guard any request against being fired twice by a UI race (e.g. two buttons, or a
// click landing before a loading flag re-renders) — wrap the call with a stable key such as the
// request path:
//
//   export const postSomething = (id) =>
//     InFlightRequests.once(`/something/${id}`, () => HTTPS.post(`/something/${id}`, payload))
export class InFlightRequests {
  static registry = new Map()

  static once(key, run) {
    const existing = InFlightRequests.registry.get(key)
    if (existing) return existing

    const promise = run().finally(() => {
      InFlightRequests.registry.delete(key)
    })
    InFlightRequests.registry.set(key, promise)
    return promise
  }
}
